import reducer from './reducers';

export { default as partiesSelectors } from './selectors';
export { default as partiesOperations } from './operations';
export { default as partiesTypes } from './types';

export default reducer;
